const transmissionOptions = [
    { id: "Automatic", label: "Automatic" },
    { id: "Manual", label: "Manual" },
];

// API key
const transmissionAPIKey = "transmission"; 

// Label
const transmissionLabel = "Transmission"; 

export { transmissionOptions, transmissionAPIKey, transmissionLabel };
